import(/* webpackMode: "eager" */ "/app/src/app/(tabs)/discover/page.tsx");
